import { render } from "./UserLayout.vue?vue&type=template&id=76664d1e&scoped=true"
const script = {}

import "./UserLayout.vue?vue&type=style&index=0&id=76664d1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@4.5.5__webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76664d1e"]])

export default __exports__